class BuyNowHandler {
    constructor() {
      this.selectors = {
        buyNowButton: '.btn.btn-two',
        variantInput: 'input[name="id"]'
      };
      
      this.init();
    }
  
    init() {
      // Handle buy now clicks
      document.addEventListener('click', (e) => {
        const buyNowBtn = e.target.closest(this.selectors.buyNowButton);
        if (buyNowBtn) {
          e.preventDefault();
          this.handleBuyNow(buyNowBtn);
        }
      });
    }
  
    async handleBuyNow(button) {
      // Find the closest variant input
      const form = button.closest('.shop-content-bottom');
      const variantInput = form?.querySelector(this.selectors.variantInput);
      
      if (!variantInput) {
        // Fallback to product page if no variant found
        window.location.href = button.href;
        return;
      }
  
      const variantId = variantInput.value;
      
      try {
        // Show loading state
        const originalText = button.textContent;
        button.textContent = 'Processing...';
        button.style.opacity = '0.7';
        button.style.pointerEvents = 'none';
  
        // Add to cart first
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });
  
        if (!response.ok) throw new Error('Failed to add item');
  
        // Redirect to checkout
        window.location.href = '/checkout';
      } catch (error) {
        // Restore button state
        button.textContent = originalText;
        button.style.opacity = '';
        button.style.pointerEvents = '';
        
        // Fallback to product page on error
        window.location.href = button.href;
      }
    }
  }
  
  // Initialize the handler
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BuyNowHandler());
  } else {
    new BuyNowHandler();
  }